module.exports = __webpack_public_path__ + "img/icon-receive.e9ad9e12.png";